import React, { useEffect, useState } from 'react';
import { Login } from './auth/Login';
import { Dashboard } from './pages/Dashboard';
import { CreateAssociations } from './pages/CreateAssociations';
import {Routes, Route, useNavigate} from 'react-router-dom';
import { AllAssociations } from './pages/AllAssociations';
import { CreateMember } from './pages/CreateMember';
import OneAssociation from './pages/OneAssociation';
import AssociationKinds from './pages/AssociationKinds';
import { OneKindAssociation } from './pages/OneKindAssociation';
import Accounts from './pages/Accounts';
import PassBook from './pages/PassBook';
import AllMembers from './pages/AllMembers';
import OneMember from './pages/OneMember';
import UpdateMember from './pages/UpdateMember';
import UnregisteredPassBook from './pages/UnregisteredPassbook';
import AssociationPassBook from './pages/AssociationPassbook';
import MassTransaction from './pages/MassTransaction';
import CommodityManager from './pages/CommodityManager';
import { Commodities } from './pages/Commodities';
import WareHouse from './pages/Warehouse';
import MomoAccount from './pages/MomoAccount';
import KindAccount from './pages/KindAccount';
import PassbookInAssociation from './pages/PassbooksInAssociation';
import { UserProfile } from './pages/UserProfile';
import { UsersPage } from './pages/UsersPage';
import { Settings } from './pages/Settings';
import Permissions from './components/Permissions';
import SavingsAccountPage from './pages/SavingsAccountPage';
import MyAccount from './pages/MyAccount';
import MassDeposit from './pages/MassDeposit';
import Expenses from './pages/Expenses';
import TradingAccount from './pages/TradingAccount';
import Cluster from './pages/Cluster';
import Community from './pages/Community';
import Inbox from './pages/Inbox';
import Season from './pages/Seasons';
import PrintScreen from './components/PrintScreen';
import PrintScreenCash from './components/PrintScreenCash';
import { PrintApplicationForms } from './components/PrintApplicationForms';
import { Layout } from './layouts/Layout';
import { Toaster, toast } from 'sonner';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import LoanAccountsPage from './components/LoanAccountsPage';
import SocietyAccountsDashboard from './pages/SocietyAccountsDashboard';
import FinancialStatements from './pages/FinancialStatements';
import PrintWithdrawals from './components/PrintWithdrawals';
import ApplicationForm from './components/ApplicationForm';
import RequestLogistics from './pages/RequestLogistics';
import KpeeLogistics from './pages/KpeeLogistics';
import SingleCashPrint from './components/SingleCashPrint';
import Salaries from './pages/Salaries';
import { Subscriptions } from './pages/Subscriptions';
import { SocietyAssets } from './pages/SocietyAssets';
import Stocks from './pages/Stocks';
import Teams from './pages/Teams';
import MyTeams from './pages/MyTeams';
import CreditOfficerDashboard from './pages/CreditOfficerDashboard';
import OperationsManagerDashboard from './pages/OperationsManagerDashboard';
import SocietyManagerPage from './pages/SocietyManagerPage';
import CashierDashboard from './pages/CashierDashboard';
import { SocietyLoans } from './pages/SocietyLoans';



function App() {
  const navigate = useNavigate();
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    if(isOnline) {
      toast.message('Connection is stable', {
        description: 'You are online',
      })
    } else {
      toast.error('No internet connection', {
        description: 'You are offline',
      })
    }
  }, [isOnline])

  useEffect(() => {
    if (!localStorage.getItem('afrifaToken')) {
      navigate("/");
    }
  }, []);
  

  return (
    <>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Routes>
              <Route path="/" element={<Login />} />
              <Route element={<Layout />}>
                <Route path="/dashboard" element={<Dashboard isOnline={isOnline} />} />
                <Route path="/association/create" element={<CreateAssociations isOnline={isOnline} />} />
                <Route path="/allassociations" element={<AllAssociations isOnline={isOnline} />} />
                <Route path="/allassociationKind/:id" element={<AssociationKinds isOnline={isOnline} />} />
                <Route path="/onekind/" element={<OneKindAssociation isOnline={isOnline} />} />
                <Route path="/member" element={<CreateMember isOnline={isOnline} />} />
                <Route path="/association/" element={<OneAssociation isOnline={isOnline} />} />
                <Route path='/accounts' element={<Accounts isOnline={isOnline} />} />
                <Route path='/Passbook/' element={<PassBook isOnline={isOnline} />} />
                <Route path='/members' element={<AllMembers isOnline={isOnline} />} />
                <Route path='/onemember/' element={<OneMember isOnline={isOnline} />} />
                <Route path='/update' element={<UpdateMember isOnline={isOnline} />} />
                <Route path='/passbook/association/' element={<AssociationPassBook isOnline={isOnline} />} />
                <Route path='/unregistered/' element={<UnregisteredPassBook isOnline={isOnline} />} />
                <Route path='/mass/transaction' element={<MassTransaction isOnline={isOnline} />} />
                <Route path='/commodities' element={<Commodities isOnline={isOnline} />} />
                <Route path="/manage/commodities" element={<CommodityManager isOnline={isOnline} />} />
                <Route path='/warehouse' element={<WareHouse isOnline={isOnline} />} />
                <Route path='/accounts/momo' element={<MomoAccount isOnline={isOnline} />} />
                <Route path='/accounts/society' element={<KindAccount isOnline={isOnline} />} />
                <Route path='/passbooks/association' element={<PassbookInAssociation isOnline={isOnline} />} />
                <Route path='/profile/page' element={<UserProfile isOnline={isOnline} />} />
                <Route path='/users' element={<UsersPage isOnline={isOnline} />} />
                <Route path='/settings' element={<Settings isOnline={isOnline} />} />
                <Route path='/permissions' element={<Permissions isOnline={isOnline} />} />
                <Route path='/savings/account' element={<SavingsAccountPage isOnline={isOnline} />} />
                <Route path='/my_account' element={<MyAccount isOnline={isOnline} />} />
                <Route path='/expenses' element={<Expenses isOnline={isOnline} />} />
                <Route path='/trade' element={<TradingAccount isOnline={isOnline} />} />
                <Route path='/massdeposit' element={<MassDeposit isOnline={isOnline} />} />
                <Route path='/cluster' element={<Cluster isOnline={isOnline} />} />
                <Route path='/community' element={<Community isOnline={isOnline} />} />
                <Route path='/inbox' element={<Inbox isOnline={isOnline} />} />
                <Route path='/seasons' element={<Season isOnline={isOnline} />} />
                <Route path='/group/print' element={<PrintScreen isOnline={isOnline} />} />
                <Route path='/group/print/cash' element={<PrintScreenCash isOnline={isOnline} />} />
                <Route path='/application/print' element={<PrintApplicationForms isOnline={isOnline} />} />
                <Route path='/loans/account' element={<LoanAccountsPage />} />
                <Route path='/society/accounts/dashboard' element={<SocietyAccountsDashboard isOnline={isOnline} />} />
                <Route path='/financial-statements' element={<FinancialStatements isOnline={isOnline} />} />
                <Route path='/withdrawals/print' element={<PrintWithdrawals isOnline={isOnline} />} />
                <Route path='/application/form/print' element={<ApplicationForm isOnline={isOnline} />} />
                <Route path='/request/logistics' element={<RequestLogistics isOnline={isOnline} />} />
                <Route path='/kpee' element={<KpeeLogistics isOnline={isOnline} />} />
                <Route path='/single/disburse_form' element={<SingleCashPrint isOnline={isOnline} />} />
                <Route path='/salaries' element={<Salaries isOnline={isOnline} />} />
                <Route path='/subscriptions' element={<Subscriptions isOnline={isOnline} />} />
                <Route path='/assets' element={<SocietyAssets isOnline={isOnline} />} />
                <Route path='/stocks' element={<Stocks isOnline={isOnline} />} />
                <Route path='/teams' element={<Teams isOnline={isOnline} />} />
                <Route path='/my-teams' element={<MyTeams isOnline={isOnline} />} />
                <Route path='/credit-officer' element={<CreditOfficerDashboard isOnline={isOnline} />} />
                <Route path='/operations-manager' element={<OperationsManagerDashboard isOnline={isOnline} />} />
                <Route path='/society-manager' element={<SocietyManagerPage isOnline={isOnline} />} />
                <Route path='/cashier' element={<CashierDashboard isOnline={isOnline} />} />
                <Route path='/society-loans' element={<SocietyLoans isOnline={isOnline} />} />
                <Route path='*' element={<h1>Page not found</h1>} />
              </Route>
      </Routes>

    </LocalizationProvider>
            <Toaster position='bottom-right' richColors/>
      </>
  );
}



export default App;
